import React, { useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { AlertDialog } from 'Shared/AlertDialog';
import FlowImportFlow from 'Shared/flows/flows-interface/FlowImportFlow';
import FlowExecutionModal from 'Shared/flows/flows-interface/FlowExecutionModal';
import { useFlowRun } from 'Shared/flows/flows-interface/useFlowRun';

const stopPropagation = (event) => event.stopPropagation();

const FlowRunButton = ({ flow, sx }) => {
    const [isConfirm, setIsConfirm] = useState(false);
    const [simpleVersion, setSimpleVersion] = useState(true);
    const [includeSubflows, setIncludeSubflows] = useState(false);
    const run = useFlowRun(flow.id, flow.post_parameters);

    const openConfirm = (event) => {
        event.stopPropagation();
        setIsConfirm(true);
    };

    const startRun = () => {
        setIsConfirm(false);
        run.runFlow();
    };

    return (
        <>
            <Tooltip title={<span style={{ fontSize: '1rem', lineHeight: '120%' }}>Run Flow</span>} arrow>
                <IconButton aria-label="run flow" onClick={openConfirm} sx={sx}>
                    <PlayArrowIcon />
                </IconButton>
            </Tooltip>
            <Box component="span" onClick={stopPropagation} sx={{ display: 'contents' }}>
                <AlertDialog
                    visible={isConfirm}
                    onClose={() => setIsConfirm(false)}
                    onAgree={startRun}
                    title="Run Flow"
                    text={`Run flow "${flow.name}"?`}
                    noButtonText="Cancel"
                    yesButtonText="Run"
                />
                <FlowImportFlow
                    flowId={flow.id}
                    name={flow.name}
                    visible={!!run.response}
                    setVisible={() => {}}
                    response={run.response}
                    setResponse={run.setResponse}
                    title={run.dialogTitle}
                    status={run.responseStatus}
                    setStatus={run.setResponseStatus}
                    simpleVersion={simpleVersion}
                    setSimpleVersion={setSimpleVersion}
                    includeSubflows={includeSubflows}
                    setIncludeSubflows={setIncludeSubflows}
                    isBackground={!!run.background}
                    onGetResult={run.fetchBackgroundResult}
                    onBackgroundReset={() => run.setBackground(null)}
                    onStop={run.stopBackgroundFlow}
                />
                <FlowExecutionModal
                    open={run.isRunning}
                    timeout={run.effectiveTimeout}
                    onStop={run.stopSyncFlow}
                    onClose={() => run.setIsRunning(false)}
                />
            </Box>
        </>
    );
};

export default FlowRunButton;
